import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { transformUnit } from '../common/utils';
import { useMobile } from '../common/hooks/use-mobile';
import defaultBrand from './images/default-brand.png';
import { getImageSrc } from '../common/utils/get-image-src';
var Brand = function Brand(props) {
  var mode = props.mode,
    pagePadding = props.pagePadding,
    brandGap = props.brandGap;
  var mobile = useMobile();
  return _jsx("div", Object.assign({
    className: classNames('w-full grid max-w-pc mx-auto', {
      'grid-cols-3': mode === 'triple',
      'grid-cols-4': mode === 'quadruple'
    }),
    style: {
      paddingLeft: transformUnit(pagePadding, mobile),
      paddingRight: transformUnit(pagePadding, mobile),
      gap: transformUnit(brandGap, mobile)
    }
  }, {
    children: props.brands.map(function (item) {
      return _jsx("div", Object.assign({
        className: 'w-full relative brand-item-wrap'
      }, {
        children: _jsx("img", {
          alt: '',
          className: 'absolute top-0 w-full h-full object-contain',
          src: item.logoPicturePath || getImageSrc(defaultBrand)
        })
      }), item.id);
    })
  }));
};
export default Brand;